import { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { useConnectionStore } from '@/stores/connectionStore'
import { Loader2, Plug, PlugZap, AlertCircle } from 'lucide-react'

export function ConnectionDialog() {
  const { config, setConfig, connect, isConnecting, isConnected, error } = useConnectionStore()
  const [localConfig, setLocalConfig] = useState(config)

  const handleConnect = async () => {
    setConfig(localConfig)
    await connect()
  }

  if (isConnected) {
    return null
  }

  return (
    <Card className="max-w-md mx-auto">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Plug className="w-5 h-5" />
          Connect to Fuseki
        </CardTitle>
        <CardDescription>
          Enter your Apache Jena Fuseki SPARQL endpoint details
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <label className="text-sm font-medium text-text">Query Endpoint</label>
          <input
            type="text"
            value={localConfig.queryEndpoint}
            onChange={(e) => setLocalConfig({ ...localConfig, queryEndpoint: e.target.value })}
            className="w-full mt-1 px-3 py-2 text-sm bg-background border border-border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
            placeholder="http://localhost:3030/dataset/query"
          />
        </div>

        <div>
          <label className="text-sm font-medium text-text">Update Endpoint</label>
          <input
            type="text"
            value={localConfig.updateEndpoint || ''}
            onChange={(e) => setLocalConfig({ ...localConfig, updateEndpoint: e.target.value })}
            className="w-full mt-1 px-3 py-2 text-sm bg-background border border-border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
            placeholder="http://localhost:3030/dataset/update"
          />
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-sm font-medium text-text">Username (optional)</label>
            <input
              type="text"
              value={localConfig.username || ''}
              onChange={(e) => setLocalConfig({ ...localConfig, username: e.target.value })}
              className="w-full mt-1 px-3 py-2 text-sm bg-background border border-border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-text">Password (optional)</label>
            <input
              type="password"
              value={localConfig.password || ''}
              onChange={(e) => setLocalConfig({ ...localConfig, password: e.target.value })}
              className="w-full mt-1 px-3 py-2 text-sm bg-background border border-border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
            />
          </div>
        </div>

        {error && (
          <div className="flex items-center gap-2 text-solution text-sm bg-solution/10 px-3 py-2 rounded-md">
            <AlertCircle className="w-4 h-4" />
            {error}
          </div>
        )}

        <Button
          onClick={handleConnect}
          disabled={isConnecting}
          className="w-full"
        >
          {isConnecting ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin mr-2" />
              Connecting...
            </>
          ) : (
            <>
              <PlugZap className="w-4 h-4 mr-2" />
              Connect
            </>
          )}
        </Button>

        <p className="text-xs text-text-muted text-center">
          Make sure Fuseki is running and CORS is enabled for this origin
        </p>
      </CardContent>
    </Card>
  )
}
